import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateContentItem as updateContentItemAPI } from '@/api/v4/content-items.api';
import { notify } from '@/ui/snackbar/notify';
import { QueryKey } from '@/config/query-client';
import { useSidebars } from '@/hooks/use-sidebars';

export const useUpdateContentItem = () => {
  const { t } = useTranslation('feed');
  const queryClient = useQueryClient();
  const { resetSidebar } = useSidebars();

  const mutation = useMutation({
    mutationFn: updateContentItemAPI,
    onSuccess: async () => {
      resetSidebar();
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.ContentItems] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.FeedContentItems],
        }),
      ]);
      notify({
        message: t`updateSuccess`,
      });
    },
    onError: (error: Error) => {
      notify({
        message: t`updateError`,
      });
      console.error(error.message);
    },
  });

  return {
    updateContentItem: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
